/* eslint-disable */
/** 
* This file contains language specific message functions for tree-shaking. 
* 
*! WARNING: Only import messages from this file if you want to manually
*! optimize your bundle. Else, import from the `messages.js` file. 
* 
* Your bundler will (in the future) automatically replace the index function 
* with a language specific message function in the build step. 
*/
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const crust_chain_about = () => `Crust is a decentralized storage network built on Polkadot, a multi-chain blockchain platform. It aims to provide a decentralized storage solution that is secure, reliable, and cost-effective. Crust allows users to store and retrieve data in a web3 manner, leveraging the power of blockchain technology to ensure data integrity and availability.
		Crust uses a combination of blockchain and decentralized storage technologies to achieve its goals. It offers incentives for users to contribute their storage space to the network, creating a distributed storage infrastructure that is resistant to censorship and single points of failure.`
